// src/api/loadingStore.js
// -----------------------------------------------------------------------------
// Pub/Sub store to track outstanding HTTP request counts across the app.
// Allows non-React code (like Axios client interceptors) to publish events
// that React context providers can subscribe to.
// -----------------------------------------------------------------------------

let count = 0;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => listener(count));
}

export const loadingStore = {
  increment() {
    count++;
    notify();
  },

  decrement() {
    count = Math.max(0, count - 1);
    notify();
  },

  subscribe(listener) {
    listeners.add(listener);
    // Fire immediately with initial value
    listener(count);
    return () => {
      listeners.delete(listener);
    };
  },

  getCount() {
    return count;
  },
};

export default loadingStore;
